module.exports = __webpack_public_path__ + "static/media/10toukaidou.fb98067c.png";